const Manage = ({ children }) => (children)

export default Manage



// WEBPACK FOOTER //
// ./src/containers/Manage/index.js